import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { IncassoFormRipartizione } from 'src/app/common/form/incasso-form-ripartizione';
import { IncassoSoggetto } from 'src/app/common/models/incasso-soggetto';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { OperationsService } from 'src/app/core/services/operations.service';
import { SezioneIncassiResponse } from '../../../models/dto/sezione-incassi-response';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { Incasso } from '../../../models/incasso';
import { SezioneIncassi } from '../../../models/sezioni/sezione-incassi';
import { IncassoAdapter } from '../incassi-edit/incasso-adapter';


@Component({
    selector: 'div [incasso-form-ripartizione]',
  templateUrl: '../../../form/incasso-form-ripartizione.html'
})

export class IncassiRipartizioneComponent extends IncassoFormRipartizione implements OnInit {
  sezione: SezioneIncassi;
  ripartizione: IncassoSoggetto;
  urlUpdate: string;
  urlReadSezioneControparti: string;
  urlReadSezioneEconomica: string;
  urlUpdatePetitumEconomico: string;

  @Output() onReturn: EventEmitter<SezioneIncassi> = new EventEmitter<SezioneIncassi>();

  constructor(protected operationService: OperationsService,
              protected campiForm: FormBuilder,
              protected helpers: HelpersService,
              protected modalNotifyService: ModalNotifyService){
    super(operationService, campiForm, helpers, modalNotifyService);
  }

  ngOnInit() {
    this.setTitle('Ripartisci Incasso');
  }

  getRipartizioneIncasso() {
    return (this.inserimento) ? new IncassoSoggetto() : this.ripartizione;
  }

  getUrlReadSezioneControparti() {
    return this.urlReadSezioneControparti;
  }

  getUrlReadSezioneEconomica(){
    return this.urlReadSezioneEconomica;
  }

  getTotaleRipartizioni(incasso: Incasso, ripartizione: IncassoSoggetto): number{
    let totale = 0;
    let newIncasso = new IncassoAdapter(incasso).incasso;
    if(newIncasso.incassiSoggetti && newIncasso.incassiSoggetti.length>0){
      newIncasso.incassiSoggetti=newIncasso.incassiSoggetti.filter(el=>el.id!==ripartizione.id);
      newIncasso.incassiSoggetti.push(ripartizione);
    }
    else {
      newIncasso.incassiSoggetti = [];
      newIncasso.incassiSoggetti.push(ripartizione);
    }
    newIncasso.incassiSoggetti.forEach(element=>totale+=element.percentualeIncasso);
    return totale;
  }

  getRequest(request: IncassoSoggetto) {
    if(this.getTotaleRipartizioni(this.incasso, request)<=100){
    if(this.inserimento) {
      this.operationService.addRipartizioneIncasso(this.urlUpdate, request, this.sezione.id, this.fascicolo.id).subscribe((response: any) => this.datiIncasso(response));
    } else {
      this.operationService.updateRipartizioneIncasso(this.urlUpdate, request, this.sezione.id).subscribe((response:any)=>this.datiIncasso(response));
    }
  }
  else {
    this.modalNotifyService.customMessage('Percentuale massima di ripartizione raggiunta.');
  }
  }

  datiIncasso(response: SezioneIncassiResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(sezione: SezioneIncassi, incasso: Incasso, urlUpdate: string, fascicolo: FascicoloFull, inserimento: boolean, ripartizione?: IncassoSoggetto) {
    this.incasso = incasso;
    this.fascicolo = fascicolo;
    this.sezione = sezione;
    this.urlUpdate = urlUpdate;
    // this.urlReadSezioneControparti = urlReadSezioneControparti;
    // this.urlReadSezioneEconomica = urlReadSezioneEconomica;
    // this.urlUpdatePetitumEconomico= urlUpdatePetitumEconomico;
    // if(idSezioneControparti) this.readSezioneControparti(idSezioneControparti);
    // if(idSezioneEconomica) this.readSezioneEconomica(idSezioneEconomica)
    this.inserimento=inserimento;
    if(!inserimento) this.ripartizione=ripartizione;
    this.createForm();
    this.populateSelect();
  }

}
